import router from '@/router'
import routes from './route'

import store from '@/store'
import layout from '@/modules/book/store/layout';
import {building} from '@/modules/book/store/building';
import {facility} from '@/modules/book/store/facility';
import {common} from '@/modules/book/store/common';
import {admin} from '@/modules/book/store/admin';
import {dashboardHome} from '@/modules/book/store/dashboard/dashboard-home';
import {dashboardMain} from '@/modules/book/store/dashboard/dashboard-main';
import {dashboardOperator} from '@/modules/book/store/dashboard/dashboard-operator';
import {dashboardManager} from '@/modules/book/store/dashboard/dashboard-manager';
import {dashboardWorker} from '@/modules/book/store/dashboard/dashboard-worker';
import {routes as storeRoutes} from '@/modules/book/store/routes';
import {process} from '@/modules/book/store/process';
import {onboarding} from '@/modules/book/store/onboarding';


const MODULE_NAME = "book"
const TRANSLATION_PREFIX = "book/"

//installs module
export default class BookModule {

  static install() {


    //add the module stores
    //by making preserveState dependant on the current state, we can add new state if missing or retain state if existing
    store.registerModule(MODULE_NAME,{namespaced:true})

    store.registerModule([MODULE_NAME,'layout'],layout);
    store.registerModule([MODULE_NAME,'building'],building);
    store.registerModule([MODULE_NAME,'facility'],facility);
    store.registerModule([MODULE_NAME,'common'],common);
    store.registerModule([MODULE_NAME,'admin'],admin);
    store.registerModule([MODULE_NAME,'dashboardHome'],dashboardHome);
    store.registerModule([MODULE_NAME,'dashboardMain'],dashboardMain);
    store.registerModule([MODULE_NAME,'dashboardOperator'],dashboardOperator);
    store.registerModule([MODULE_NAME,'dashboardManager'],dashboardManager);
    store.registerModule([MODULE_NAME,'dashboardWorker'],dashboardWorker);
    store.registerModule([MODULE_NAME,'routes'],storeRoutes);
    store.registerModule([MODULE_NAME,'process'],process);
    store.registerModule([MODULE_NAME,'onboarding'],onboarding);

    //add the module translations
    let enMap = new Map();
    enMap.set(TRANSLATION_PREFIX + "admin",() => import("@/modules/book/translations/en/admin.json"));
    enMap.set(TRANSLATION_PREFIX + "building",() => import("@/modules/book/translations/en/building.json"));
    enMap.set(TRANSLATION_PREFIX + "dashboard",() => import("@/modules/book/translations/en/dashboard.json"));
    enMap.set(TRANSLATION_PREFIX + "event",() => import("@/modules/book/translations/en/event.json"));
    enMap.set(TRANSLATION_PREFIX + "facility",() => import("@/modules/book/translations/en/facility.json"));
    enMap.set(TRANSLATION_PREFIX + "navbar",() => import("@/modules/book/translations/en/navbar.json"));
    enMap.set(TRANSLATION_PREFIX + "process",() => import("@/modules/book/translations/en/process.json"));
    enMap.set(TRANSLATION_PREFIX + "public",() => import("@/modules/book/translations/en/public.json"));
    enMap.set(TRANSLATION_PREFIX + "technical-info",() => import("@/modules/book/translations/en/technical-info.json"));

    let deMap = new Map();
    deMap.set(TRANSLATION_PREFIX + "admin",() => import("@/modules/book/translations/de/admin.json"));
    deMap.set(TRANSLATION_PREFIX + "building",() => import("@/modules/book/translations/de/building.json"));
    deMap.set(TRANSLATION_PREFIX + "dashboard",() => import("@/modules/book/translations/de/dashboard.json"));
    deMap.set(TRANSLATION_PREFIX + "event",() => import("@/modules/book/translations/de/event.json"));
    deMap.set(TRANSLATION_PREFIX + "facility",() => import("@/modules/book/translations/de/facility.json"));
    deMap.set(TRANSLATION_PREFIX + "navbar",() => import("@/modules/book/translations/de/navbar.json"));
    deMap.set(TRANSLATION_PREFIX + "process",() => import("@/modules/book/translations/de/process.json"));
    deMap.set(TRANSLATION_PREFIX + "public",() => import("@/modules/book/translations/de/public.json"));
    deMap.set(TRANSLATION_PREFIX + "technical-info",() => import("@/modules/book/translations/de/technical-info.json"));

    let translationMap = new Map();
    translationMap.set("en",enMap);
    translationMap.set("de",deMap);

    store.commit("translation/updateImportMap", translationMap);
    this.installNameSpace();
  }

  static installNameSpace() {
    //namespace that is used for all or most components
    let globalNamespace = ['book/navbar'];

    let namespaces = globalNamespace;
    if(store.state.translation.namespaces) {
      namespaces = namespaces.concat(store.state.translation.namespaces);
    }

    store.commit("translation/updateNamespaces", namespaces);
    store.commit("translation/loadNamespaces");
  }

  static installRoutes() {
    routes.forEach(function(route){
      router.addRoute(route);
    });
  }
}
